jQuery(function ($){
  $(document).ready(function() {
    $('.js-drawer').drawer();
  });
});
